import { formatNumber } from '@local_modules/flokit'
import { makeXeroLink } from '@local_modules/generic/xero/utilities/xero-links'

export function makeSourceColumns (context, entitiesMap) {
  const columnDefs = []

  columnDefs.push({
    headerName: 'Source Currency',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return cellParams.data.transaction?.source_currency_code
    },
    width: 100
  })

  columnDefs.push({
    headerName: 'Source Amount',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return cellParams.data.transaction?.ledger_amount * (cellParams.data.transaction?.source_currency_rate || 1)
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null

      return formatNumber(cellParams.value, 2)
    },
    type: 'numericColumn',
    width: 100
  })

  columnDefs.push({
    headerName: 'Source Currency Rate',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null
      if (!cellParams.data.transaction?.source_currency_rate) return 1

      return cellParams.data.transaction?.source_currency_rate
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null

      return formatNumber(cellParams.value, 2)
    },
    type: 'numericColumn',
    width: 100
  })

  columnDefs.push({
    headerName: 'Source Currency Rate (Conversion)',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null
      if (!cellParams.data.transaction?.source_currency_rate) return 1

      return 1 / cellParams.data.transaction?.source_currency_rate
    },
    valueFormatter: function (cellParams) {
      if (!cellParams.value) return null

      return formatNumber(cellParams.value, 2)
    },
    type: 'numericColumn',
    width: 100
  })

  columnDefs.push({
    headerName: 'Source',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return `${cellParams.data.transaction?.source_document_number || ''}`.trim()
    }
  })

  columnDefs.push({
    headerName: 'Source Type',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return `${cellParams.data.transaction?.source_type_api} > [${cellParams.data.transaction?.source_xero_source_type}] [${cellParams.data.transaction?.source_xero_status}]`.trim()
    }
  })

  columnDefs.push({
    headerName: 'Source Xero Id',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return `${cellParams.data.transaction?.source_xero_id}`.trim()
    }
  })

  columnDefs.push({
    headerName: 'Link to Xero',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      const entityShortcode = entitiesMap.get(cellParams.data.transaction?.chart_of_account_accounting_organisation_id)?.xero_shortcode
      if (!entityShortcode) return null

      const xeroUrl = makeXeroLink(cellParams.data.transaction?.journal_xero_source_type, {
        shortCode: getEntityShortcode(cellParams, entitiesMap),
        sourceId: cellParams.data.transaction?.source_xero_id
      })
      if (!xeroUrl) return null

      return xeroUrl
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      const sourceText = [
        cellParams.data.transaction?.source_xero_id.slice(0, 4),
        '...',
        cellParams.data.transaction?.source_xero_id.slice(-4)
      ].join('') + ` ${cellParams.data.transaction?.journal_xero_source_type || ''}`
      return `<a href="${cellParams.value}" target="_blank">${sourceText}</a>`
    },
    width: 180
  })

  columnDefs.push({
    headerName: 'Source Contact',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      if (!cellParams.data.transaction?.contact_id) return null

      return `${cellParams.data.transaction?.contact_name}`
    },
    cellRenderer: function (cellParams) {
      if (!cellParams.value) return null

      const entityShortcode = getEntityShortcode(cellParams, entitiesMap)
      if (!entityShortcode) return null

      const xeroUrl = makeXeroLink('Contact', {
        shortCode: entityShortcode,
        xeroContactId: cellParams.data.transaction?.contact_xero_id
      })
      return `[<a href="${xeroUrl}" target="_blank">Xero</a>] ${cellParams.data.transaction?.contact_name}`
    },
    width: 180
  })

  columnDefs.push({
    headerName: 'is last journal of source',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return cellParams.data.transaction?.is_last_journal_of_source
    }
  })

  columnDefs.push({
    headerName: 'has no reversal',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return cellParams.data.transaction?.has_no_reversal
    }
  })

  columnDefs.push({
    headerName: 'Xero Created At',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return cellParams.data.transaction?.journal_xero_created_at
    }
  })

  columnDefs.push({
    headerName: 'Journal',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return `${cellParams.data.transaction?.journal_xero_id} (${cellParams.data.transaction?.journal_xero_source_type})`
    }
  })

  columnDefs.push({
    headerName: 'Journal Number',
    valueGetter: function (cellParams) {
      if (getCellReturnNull(cellParams)) return null

      return `${cellParams.data.transaction?.journal_number}`
    }
  })

  return columnDefs
}

function getCellReturnNull (cellParams) {
  if (cellParams.data.type === 'break') return true
  if (cellParams.data.type === 'dateGroup') return true
  if (cellParams.data.type === 'entityPair') return true
  return false
}

function getEntityShortcode (cellParams, entitiesMap) {
  return entitiesMap.get(cellParams.data.transaction?.chart_of_account_accounting_organisation_id)?.xero_shortcode
}
